export default function Rust_Match() {
  return (
    <div>
      <h1>Rust_Match Component</h1>
      <p>This is the Rust_Match page.</p>
    </div>
  );
}
